import { render, staticRenderFns } from "./TsAddUserModal.vue?vue&type=template&id=d1892cc4&"
import script from "./TsAddUserModal.vue?vue&type=script&lang=ts&"
export * from "./TsAddUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports